import { render, staticRenderFns } from "./fpshistory_sim.vue?vue&type=template&id=5007421e&scoped=true&"
import script from "./fpshistory_sim.vue?vue&type=script&lang=js&"
export * from "./fpshistory_sim.vue?vue&type=script&lang=js&"
import style0 from "./fpshistory_sim.vue?vue&type=style&index=0&id=5007421e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007421e",
  null
  
)

export default component.exports